import dotProp from 'dot-prop-immutable'
import { INSERT_SET, REMOVE_SET, SELECT_SET, SPLIT_SET, MERGE_SET, REMOVE_FRAME } from '../../constants/projectActions'
import perMeterCalc from '../../utils/perMeterCalc'
import { disallowToResize } from './resizable'
import perPixelCalc from '../../utils/perPixelCalc'
import findSetPosition from '../../utils/findSetPosition'

export const insertSet = index => (dispatch, ownState) => {
  const wantedSet = dotProp.get(ownState(), `products.sets.${index}.sets`)

  dispatch({ type: INSERT_SET, set: wantedSet })
  dispatch(disallowToResize())
}

export const selectSet = index => dispatch => {
  dispatch(disallowToResize())
  dispatch({ type: SELECT_SET, index })
}

export const splitSet = () => (dispatch, ownState) => {
  const selectedIndex = dotProp.get(ownState(), `project.selectedIndex`, -1)
  const perMeter = dotProp.get(ownState(), `project.background.perMeter`)
  const setFrames = dotProp.get(ownState(), `project.sets.${selectedIndex}`, [])

  const frames = setFrames.data.map(frame => ({
    width: frame.width,
    height: frame.height,
    tmpWidth: perMeterCalc(frame.width, perMeter),
    tmpHeight: perMeterCalc(frame.height, perMeter),
    borderColor: frame.borderColor || "",
    borderType: frame.borderType || "noframe",
    borderWidth: frame.borderWidth || 0,
    position: {
      x: perMeterCalc(frame.x, perMeter) + setFrames.position.x,
      y: perMeterCalc(frame.y, perMeter) + setFrames.position.y,
    },
    setPosition: {
      x: perMeterCalc(frame.x, perMeter) + setFrames.position.x,
      y: perMeterCalc(frame.y, perMeter) + setFrames.position.y,
    },
    setIndex: selectedIndex,
    selectedImage: frame.selectedImage ? frame.selectedImage : null,
  }))

  dispatch({ type: SPLIT_SET, frames })
  dispatch({ type: REMOVE_SET, index: selectedIndex })
}

export const mergeSet = () => (dispatch, ownState) => {
  const perMeter = dotProp.get(ownState(), `project.background.perMeter`)
  const selectedIndex = dotProp.get(ownState(), 'project.selectedIndex')
  const setIndex = dotProp.get(ownState(), `project.pictures.${selectedIndex}.setIndex`, -1)
  const pictures = dotProp.get(ownState(), 'project.pictures').filter(pic => pic.setIndex === setIndex)

  const set = dotProp.get(ownState(), `project.sets.${setIndex}`)

  set.position = findSetPosition(pictures)
  set.data = pictures.map(picture => {
    let index = dotProp.get(ownState(), 'project.pictures').indexOf(picture)
    dispatch({ type: REMOVE_FRAME, index })

    return {
      width: picture.width,
      height: picture.height,
      x: perPixelCalc(picture.setPosition.x - set.position.x, perMeter),
      y: perPixelCalc(picture.setPosition.y - set.position.y, perMeter),
      selectedImage: picture.selectedImage ? picture.selectedImage : null,
    }
  })

  set.index = setIndex

  dispatch({ type: MERGE_SET, set })
}



// WEBPACK FOOTER //
// ./src/actions/project/set.js